import { render, staticRenderFns } from "./ViewContactPerson.vue?vue&type=template&id=81a876cc&"
import script from "./ViewContactPerson.vue?vue&type=script&lang=js&"
export * from "./ViewContactPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports